import { Loading } from "components/form";
import React, { useEffect } from "react";
import { useGallery } from "store/gallery";

export default function Collections({onSelect}) {
  const {
    collections,
    current_collection,
    getList,
    getCollections,
    dispatch,
    collectionLoading,
    loading,
  } = useGallery();

  useEffect(() => {
    if (!collections) {
      dispatch(getCollections());
    }
  }, [collections, dispatch, getCollections]);

  const handleChangeCollection = (collection) => {
    if (!loading) {
      dispatch(getList(collection));
    }
     // Call the onSelect prop to close the menu
    if (onSelect) {
      onSelect();
    }
  };

  return (
    <div className="ml-4 h-auto flex flex-col border-l-2 border-gray-300 p-4 rounded shadow-md bg-white">
      {/* عنوان بخش */}
      <h1 className="font-bold text-lg text-violet-700 mb-4">دسته‌بندی‌ها</h1>
      {collectionLoading ? (
        <Loading />
      ) : collections && collections.length > 0 ? (
        <ul className="w-full mt-2 space-y-2">
          {collections.map((item, index) => (
            <li
              key={`collectionItem${index}`}
              className={`text-sm p-3 rounded-lg hover:shadow-md hover:bg-violet-100 cursor-pointer transition ${
                current_collection === item.value
                  ? "bg-violet-200 text-violet-900 font-bold"
                  : "text-gray-700"
              } ${loading ? "text-gray-300 cursor-not-allowed" : ""}`}
              onClick={() => handleChangeCollection(item.value)}
            >
              {item.lable || "نامشخص"}
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-gray-500 text-center text-sm">
          دسته‌بندی‌ای یافت نشد.
        </div>
      )}
    </div>
  );
}
